export default "__VITE_ASSET__g1niJt3o__";